module.exports = __webpack_public_path__ + "media/images/times-octagon-b8f53c0a40aa55a83f82b5ee0325d49e.svg";